module.exports = __webpack_public_path__ + "da184e7e93b5817dfe36a4626e4137c4.MP3";